import { render, staticRenderFns } from "./SurveyDetails.vue?vue&type=template&id=5aa1fa42&"
import script from "./SurveyDetails.vue?vue&type=script&lang=js&"
export * from "./SurveyDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports